module.exports = __webpack_public_path__ + "img/Group 8845.4fa45051.svg";